import React from 'react';
import Feature from '../feature/Feature';
import { InputText } from 'primereact/inputtext';
import { type paths } from '../../../../endpoint/Schema';
import { Icons } from '../../../../assets/icons';

interface IRewardeatureProps {
  featureSettings:
    | paths['/api/v2/admin/feature-setting']['get']['responses']['200']['content']['application/json']
    | undefined;
  setFeatureSettings: React.Dispatch<
    React.SetStateAction<
      | paths['/api/v2/admin/feature-setting']['get']['responses']['200']['content']['application/json']
      | undefined
    >
  >;
}

export default function RewardFeature({
  featureSettings,
  setFeatureSettings,
}: IRewardeatureProps) {
  function handleDClubChecked(checked: boolean) {
    setFeatureSettings((prev) => ({
      ...prev,
      rewardSettings: {
        ...prev?.rewardSettings,
        enabled: checked,
        rewardName: featureSettings?.rewardSettings?.rewardName ?? 'Acorn',
        amazonVoucherCountry:
          prev?.rewardSettings?.amazonVoucherCountry ?? 'Uk',
      },
    }));
  }
  return (
    <Feature
      icon={Icons.ic_reward}
      image="img_reward"
      title="Reward"
      description="This feature allows users to track their rewards status and redeem earned rewards for vouchers. Users can conveniently monitor their rewards balance and redeem them for vouchers, enhancing their overall app experience and providing added value for their loyalty and engagement."
      checked={featureSettings?.rewardSettings?.enabled ?? false}
      onChange={handleDClubChecked}
    >
      <div
        className={`flex flex-col p-5 mb-6 rounded-xl ${featureSettings?.rewardSettings?.enabled ? 'bg-g10 shadow-[0px_4px_12px_rgba(0,0,0,0.1)]' : 'bg-whiteSmoke mt-6'}`}
      >
        <div className="w-[40%] max-w-xl min-w-96">
          <div className="text-base mb-6">
            Do you plan to customize reward name?
            <br />
          </div>
          <div>Reward name</div>
          <InputText
            value={featureSettings?.rewardSettings?.rewardName ?? ''}
            onChange={(e) => {
              setFeatureSettings((prev) => ({
                ...prev,
                rewardSettings: {
                  ...prev?.rewardSettings,
                  enabled: featureSettings?.rewardSettings?.enabled,
                  rewardName: e.target.value,
                  amazonVoucherCountry:
                    prev?.rewardSettings?.amazonVoucherCountry ?? 'Uk',
                },
              }));
            }}
            className="mt-3 p-inputtext-lg w-full"
          />
        </div>
      </div>
    </Feature>
  );
}
